import { render } from "./countrieslist.vue?vue&type=template&id=19b04f75"
import script from "./countrieslist.vue?vue&type=script&lang=js"
export * from "./countrieslist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__